import React, { useEffect, useState } from "react";
import DTOGoalDetailView from "./DTOGoalDetailView";
import GoalDetailViewPresenter from "./GoalDetailViewPresenter";
import { useTranslation } from "react-i18next";

interface PropVal {
  goalData: any;
  handleClose?: any;
}
function GoalDetailViewController({ goalData, handleClose }: PropVal) {
  const { t } = useTranslation();
  return (
    <div>
      <DTOGoalDetailView />
      <GoalDetailViewPresenter
        trans={t}
        goalData={goalData}
        handleCloseGoalDetailView={(val: any) => handleClose(val)}
      />
    </div>
  );
}

export default GoalDetailViewController;
